import styled, { createGlobalStyle } from 'styled-components'

export const Wrapper = styled.div`
  height: 100vh;
`

export const Header = styled.div`
  position: fixed;
  background: #fff;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 96px;
  box-shadow: 1px 0 4px rgba(0, 0, 0, 0.1);
  z-index: 9;
  & > div:first-child {
    flex-basis: 14%;
  }
`

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  height: 100vh;
`

export const GlobalBody = createGlobalStyle`
  body {
    overscroll-behavior-x: none;
  }
`
